// extracted by mini-css-extract-plugin
export default {"container":"IgIX3N","time":"OOyOrw","title":"jklKJG","chevron":"X0YpLt"};